// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1IOdD","badges":"styles_badges__1fUyt"};